import {
  Typography,
  Box,
  Divider,
  Grid2
} from "@mui/material";
import OpenTradingMobileStyle from "./OpenAccountMobile.module.css";
import en from "../../../i18n/English/Home/openAccount.json";
import hi from "../../../i18n/Hindi/Home/openAccount.json";
import kn from "../../../i18n/Kannada/Home/openAccount.json";
import ma from "../../../i18n/Marathi/Home/openAccount.json";
import gu from "../../../i18n/Gujarati/Home/openAccount.json"
import { useLanguage } from "../../../Context/LangContext";
export default function OpenAccountMobileView() {
  const translations = { en, hi, kn, ma, gu };
  const { language } = useLanguage();
  const t = translations[language];
  return (
    <Box className={OpenTradingMobileStyle.mainBox}>
      <Typography className={OpenTradingMobileStyle.honestText}
      sx={{"fontWeight":600}}
        dangerouslySetInnerHTML={{ __html: t.honestHeading }} >

      </Typography>
      <Grid2 className={OpenTradingMobileStyle.mobileBox}>
        <Box className={OpenTradingMobileStyle.stockMobileBox}></Box>
        <Box className={OpenTradingMobileStyle.stockMobileSubBox}>
          <Typography className={OpenTradingMobileStyle.pricing}
            dangerouslySetInnerHTML={{ __html: t.pricingTitle }}>
            {/* Pricing */}
          </Typography>
          <Typography className={OpenTradingMobileStyle.rupees}>₹0</Typography>
          <Typography className={OpenTradingMobileStyle.charges}
            dangerouslySetInnerHTML={{ __html: t.accountCharges }}>
            {/* Account Opening Charges */}
          </Typography>
          <Divider
            orientation="horizontal"
            className={OpenTradingMobileStyle.divider}
          />
        </Box>
      </Grid2>
      <Grid2 className={OpenTradingMobileStyle.setupBox}>
        <Typography className={OpenTradingMobileStyle.setup}
          dangerouslySetInnerHTML={{ __html: t.getStarted }} style={{ fontWeight: 600 }}>
          {/* Hey, let's get you set up with a trading account! */}
        </Typography>
        <Typography className={OpenTradingMobileStyle.discover}
          dangerouslySetInnerHTML={{ __html: t.discover }}>
          {/* Discover the blend of tech and traditional trading. */}
        </Typography>
        <Box className={OpenTradingMobileStyle.download}>
          <Box className={OpenTradingMobileStyle.googlePlay} onClick={() => window.open('https://play.google.com/store/apps/details?id=com.triveni.xts&pcampaignid=web_share')} />
          <Box className={OpenTradingMobileStyle.appStore} onClick={() => window.open('https://apps.apple.com/in/app/tradeboss-broking/id6753873589')} />
        </Box>
      </Grid2>
    </Box>
  );
}
